export default {"src":"/_next/static/media/powered_by_aeropay.fdfc69c9.svg","height":44,"width":141,"blurWidth":0,"blurHeight":0};